export const privacyHtml = `
<h2>Privacy Policy</h2>
<p><em>Last updated: July 4, 2026</em></p>

<h3>1. Introduction</h3>
<p>Boostly ("we", "us", or "our") respects your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use our Service.</p>

<h3>2. Information We Collect</h3>
<p><strong>Information you provide:</strong></p>
<ul>
  <li>Account information (email, name, profile picture) from authentication providers.</li>
  <li>Payment information processed through third-party payment processors.</li>
  <li>Communications you send to us (support requests, feedback).</li>
</ul>

<p><strong>Information collected automatically:</strong></p>
<ul>
  <li>Device information (device model, OS version, app version).</li>
  <li>Usage data (features used, session duration, interaction patterns).</li>
  <li>Log data (IP address, access times, pages viewed).</li>
</ul>

<h3>3. How We Use Your Information</h3>
<p>We use your information to:</p>
<ul>
  <li>Provide, operate, and maintain the Service.</li>
  <li>Process transactions and deliver purchased engagement services.</li>
  <li>Authenticate your identity and manage your account.</li>
  <li>Communicate with you about updates, promotions, and support.</li>
  <li>Detect and prevent fraud, abuse, and security issues.</li>
  <li>Improve and optimize the Service.</li>
</ul>

<h3>4. Third-Party Services</h3>
<p>We share information with third parties only as necessary to provide the Service:</p>
<ul>
  <li><strong>Authentication providers</strong> (Google, Facebook, X, Telegram) for sign-in.</li>
  <li><strong>Payment processors</strong> for handling financial transactions.</li>
  <li><strong>Social media platforms</strong> to deliver engagement services you purchased.</li>
  <li><strong>Analytics providers</strong> to understand usage patterns.</li>
</ul>
<p>Each third-party service has its own privacy policy. We encourage you to review them.</p>

<h3>5. Data Retention</h3>
<p>We retain your personal information for as long as your account is active or as needed to provide the Service. We may retain certain information as required by law or for legitimate business purposes.</p>

<h3>6. Data Security</h3>
<p>We implement industry-standard security measures to protect your data, including encryption in transit (TLS) and at rest. However, no method of electronic transmission or storage is 100% secure.</p>

<h3>7. Your Rights</h3>
<p>Depending on your jurisdiction, you may have the right to:</p>
<ul>
  <li>Access the personal information we hold about you.</li>
  <li>Request correction of inaccurate data.</li>
  <li>Request deletion of your personal data.</li>
  <li>Object to or restrict certain processing.</li>
  <li>Data portability.</li>
</ul>
<p>To exercise these rights, contact us at support@boostly.chainlabsdev.com.</p>

<h3>8. Children's Privacy</h3>
<p>The Service is not intended for children under 16. We do not knowingly collect personal information from children under 16. If you believe we have collected such information, please contact us immediately.</p>

<h3>9. International Data Transfers</h3>
<p>Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place for such transfers.</p>

<h3>10. Changes to This Policy</h3>
<p>We may update this Privacy Policy from time to time. We will notify you of material changes through the Service or via email.</p>

<h3>11. Contact</h3>
<p>For questions about this Privacy Policy, contact us at support@boostly.chainlabsdev.com.</p>
`.trim();
